import { required, Validator } from '@/entities/validation';
import { Group } from './model';

export const validate: Validator<Group> = record => [
  ...required(record.title, 'title'),
];
